export default "/react/card-desktop-54ec3b0b.png";